import { Grid } from '@mui/material';
import axios from 'axios';
import React from 'react';
import { alertRef } from '../../App';
import { Button } from '../../Components/StyledComponents';
import { convertCost } from '../../Utils/functions';
import './CommerceCouponInfo.scss';

const couponVariant = {
    '상품증정' : '#d8ead3',
    '% 할인' : '#ffe6b4',
    '1+1' : '#cce0ff',
    '원 할인' : '#ffddda'
}

const couponTextVariant = {
    '상품증정' : '#3d9822',
    '% 할인' : '#ffaa00',
    '1+1' : '#0064ff',
    '원 할인' : '#f95f53'
}

const CommerceCouponInfo = ({info, deleteCoupon, closeModal }) => {

    return (
        <div className='coupon-info'>
            <div className='row between'>
                {
                    info.isCheck === 'Pending' &&
                    <div className='type-box' style={{ backgroundColor : '#f95f53', color : 'white'}}>
                        검수중
                    </div>
                }

                {
                    info.isCheck === 'Stop' &&
                    !(info.IsLimit && info.StockCount == 0) &&
                    <div className='row' onClick={() => {
                        alertRef.current.showAlert({ title : `쿠폰 판매 중지를 해제 하시겠어요?`, subWarnTitle : '요청시 앱/웹 에서 쿠폰이 노출 되며\n판매가 다시 시작됩니다.', isConfirm : true, confirmText : '요청하기', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();deleteCoupon(info._id.$oid)} })
                    }} style={{ cursor : 'pointer' }}>
                        <div className='type-box' style={{ backgroundColor : 'white', color : '#f95f53', borderColor : '#f95f53', borderStyle : 'solid', borderWidth : 1 }}>
                            판매 중지 해제
                        </div>
                    </div>
                }

                {
                    info.isCheck === 'Reject' &&
                    <div className='row'>
                        <div className='type-box' style={{ backgroundColor : '#f95f53', color : 'white'}}>
                            반려
                        </div>
                        <p className='reason'>반려사유 : {info.Reason}</p>
                    </div>
                }
                {
                    (info.isCheck === 'Done' && info.IssuedCount > 0 ) &&
                    <div className='row' onClick={() => {
                        alertRef.current.showAlert({ title : `쿠폰 판매를 중지 하시겠어요?`, subWarnTitle : '요청시 앱/웹 에서 쿠폰이 노출 되지 않으며\n판매가 중지됩니다.', isConfirm : true, confirmText : '요청하기', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();deleteCoupon(info._id.$oid)} })
                    }} style={{ cursor : 'pointer' }}>
                        <div className='type-box' style={{ backgroundColor : 'white', color : '#f95f53', borderColor : '#f95f53', borderStyle : 'solid', borderWidth : 1 }}>
                            판매 중지하기
                        </div>
                    </div>
                }
                <img src={require('../../aseets/icons/close.svg').default} style={{ width : 31, height : 31 }} onClick={() => closeModal()}/>
            </div>
            <div className='row' style={{ marginTop : 8 }}>
                <img src={"https://cdn.syrupfriends.com/Images/Commerce/" + info.Img[0]} className='coupon-img'/>
                <div>
                    <p className='coupon-title'>{info.Name}</p>
                    <p className='coupon-info'>정가 : {convertCost(info.OriginPrice)}원</p>
                    <p className='coupon-info'>할인율 : {info.DiscountRate}%</p>
                    <p className='coupon-info'>판매가 : {convertCost(info.Price)}원</p>
                </div>
            </div>
            <div className='info-box'>
                <p className='coupon-info-text'>{info.Description}</p>
            </div>
            <div className='row'>
                <p className='info-text'>판매수 : {convertCost(info.IssuedCount)}</p>
                <p className='info-text'>사용수 : {convertCost(info.UsedCount)}</p>
            </div>
            {
                info.IsLimit &&
                <div className='row'>
                    <p className='info-text'>제한 수량 : {convertCost(info.LimitCount)}</p>
                    <p className='info-text'>남은 수량 : {convertCost(info.StockCount )}</p>
                </div>
            }
            {
                info.Img.length > 1 &&
                <p className='image-text'>추가 이미지</p>
            }
            <Grid container direction={'row'}  alignItems="center" columns={12}>
                {
                    info.Img.length > 1 &&
                    info.Img.map((data,i) => {
                        if(i !== 0){
                            return (
                                <Grid item xs={4} >
                                    <img src={"https://cdn.syrupfriends.com/Images/Commerce/" + data} className='coupon-img-add'/>
                                </Grid>
                            )
                        }
                    })
                }
            </Grid>
            {
                (info.IssuedCount === 0 && (info.isCheck === 'Pending' || info.isCheck === 'Done') ) &&
                <div className='btn-row'>
                    <Button
                        variant="gray"
                        fontSize={16}
                        style={{ width : 118, alignSelf: 'flex-end' }}
                        onClick={() => alertRef.current.showAlert({ title : `정말 쿠폰을 삭제하시겠어요?`, isConfirm : true, confirmText : '삭제', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();deleteCoupon(info._id.$oid)} })}
                    >
                        쿠폰 삭제
                    </Button>
                </div>
            }
        </div>
    )
}

export default CommerceCouponInfo;